export const Role = {
    ADMIN: 'agent',
    CUSTOMER: 'customer',
    CUSTOMER_ADMIN:'customer_admin',
    PROSPECT:'prospect'
}